"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonApiTypeSchemaSchema = void 0;
exports.JsonApiTypeSchemaSchema = {
    "$id": "https://www.redbull.com/schemas/types/jsonapi-resource.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "JsonApiTypeSchema",
    "description": "Meta schema for generic jsonapi type definition",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "id": {
            "type": "string",
            "pattern": "^(rrn(:([a-z\\-]+)))(:[a-zA-Z0-9\\d\\-_]+)?(:([\\d]+))?$"
        },
        "type": {
            "type": "string",
            "enum": [
                "rrn:types:jsonapi-resource"
            ]
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "examples": {
                    "type": "array",
                    "items": {
                        "type": "object"
                    }
                },
                "displayName": {
                    "type": "string",
                    "pattern": "^[A-Za-z0-9]+$"
                },
                "description": {
                    "type": "string"
                },
                "schema": {
                    "type": "object",
                    "properties": {
                        "properties": {
                            "description": "Those are the properties of the schema",
                            "type": "object",
                            "properties": {
                                "additionalProperties": true,
                                "type": {
                                    "type": "object",
                                    "properties": {
                                        "additionalProperties": false,
                                        "type": {
                                            "type": "string",
                                            "enum": [
                                                "string"
                                            ]
                                        }
                                    }
                                },
                                "attributes": {
                                    "type": "object",
                                    "properties": {
                                        "additionalProperties": true,
                                        "properties": {
                                            "patternProperties": {
                                                "^[a-zA-Z]+$": {
                                                    "type": "object",
                                                    "properties": {
                                                        "displayName": {
                                                            "type": "string",
                                                            "pattern": "^[A-Za-z0-9]+$"
                                                        }
                                                    },
                                                    "examples": [
                                                        {
                                                            "url": {
                                                                "type": "string",
                                                                "displayName": "VideoLink"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        }
                                    },
                                    "examples": [
                                        {
                                            "schema": null,
                                            "type": "object",
                                            "properties": {
                                                "type": {
                                                    "type": "string",
                                                    "enum": [
                                                        "example"
                                                    ]
                                                },
                                                "attributes": {
                                                    "type": "object",
                                                    "properties": {
                                                        "url": {
                                                            "type": "string",
                                                            "displayName": "Example",
                                                            "pattern": "examplePattern"
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    ]
                                }
                            },
                            "required": [
                                "type"
                            ]
                        }
                    },
                    "required": [
                        "properties"
                    ]
                },
                "attributes": {
                    "type": "object",
                    "additionalProperties": false,
                    "patternProperties": {
                        "^[a-zA-Z]+$": {
                            "type": "object",
                            "additionalProperties": false,
                            "properties": {
                                "type": {
                                    "type": "array",
                                    "items": {
                                        "anyOf": [
                                            {
                                                "type": "string",
                                                "format": "uri"
                                            },
                                            {
                                                "type": "string",
                                                "enum": [
                                                    "boolean",
                                                    "integer",
                                                    "number",
                                                    "string"
                                                ]
                                            }
                                        ]
                                    },
                                    "minItems": 1
                                },
                                "description": {
                                    "type": "string"
                                },
                                "deprecated": {
                                    "type": "string",
                                    "enum": [
                                        "warn",
                                        "no-write"
                                    ]
                                },
                                "enum": {
                                    "type": "array"
                                },
                                "multiple": {
                                    "type": "boolean"
                                },
                                "required": {
                                    "type": "boolean"
                                },
                                "pattern": {
                                    "type": "string"
                                }
                            },
                            "required": [
                                "type"
                            ]
                        }
                    }
                },
                "relationships": {
                    "type": "object",
                    "patternProperties": {
                        "^[a-zA-Z]+$": {
                            "type": "object",
                            "additionalProperties": false,
                            "properties": {
                                "type": {
                                    "type": "array",
                                    "items": {
                                        "type": "string",
                                        "format": "uri"
                                    },
                                    "minItems": 1
                                },
                                "description": {
                                    "type": "string"
                                },
                                "calculated": {
                                    "type": "boolean"
                                },
                                "deprecated": {
                                    "type": "string"
                                },
                                "multiple": {
                                    "type": "boolean"
                                },
                                "required": {
                                    "type": "boolean"
                                }
                            },
                            "required": [
                                "type"
                            ]
                        }
                    }
                },
                "deprecated": {
                    "type": "string"
                }
            },
            "required": [
                "displayName"
            ]
        },
        "relationships": {
            "type": "object",
            "properties": {
                "groups": {
                    "type": "object",
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "properties": {
                                    "id": {
                                        "type": "string",
                                        "pattern": "^(rrn(:([a-z\\-]+)))(:[a-zA-Z0-9\\d\\-_]+)?(:([\\d]+))?$"
                                    },
                                    "type": {
                                        "type": "string",
                                        "pattern": "^(rrn(:([a-z\\-]+)))"
                                    }
                                }
                            }
                        }
                    }
                },
                "inherits": {
                    "type": "object",
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "properties": {
                                    "id": {
                                        "type": "string"
                                    },
                                    "type": {
                                        "type": "string",
                                        "enum": [
                                            "rrn:types:jsonapi-resource"
                                        ]
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        "meta": {
            "type": "object",
            "additionalProperties": false,
            "patternProperties": {
                "^[a-zA-Z]+$": {
                    "type": "object",
                    "additionalProperties": false,
                    "properties": {
                        "type": {
                            "type": "array",
                            "items": {
                                "anyOf": [
                                    {
                                        "type": "string",
                                        "enum": [
                                            "boolean",
                                            "integer",
                                            "number",
                                            "object",
                                            "string"
                                        ]
                                    }
                                ]
                            },
                            "maxItems": 1,
                            "minItems": 1
                        },
                        "description": {
                            "type": "string"
                        },
                        "calculated": {
                            "type": "boolean"
                        },
                        "deprecated": {
                            "type": "string"
                        },
                        "enum": {
                            "type": "array"
                        },
                        "multiple": {
                            "type": "boolean"
                        }
                    },
                    "required": [
                        "type"
                    ]
                }
            }
        }
    },
    "required": [
        "id",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,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